import { AmplifyEventBus } from "aws-amplify-vue";
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["insertAccount", "initializeSeasons", "initializeBrands"]),
    // アカウント初期化
    async initializeAccount(username, password) {
      // まずサインインし認証を得る
      let user = await this.doSignIn(username, password);

      // アカウントに必要な情報を作成
      await this.insertAccount(user.username);

      // Issue #75
      // Cognitoのユーザ情報を取得し直すため（？）サインアウトしてサインインし直す
      await this.$Amplify.Auth.signOut();
      user = await this.doSignIn(username, password);

      // 作業項目を初期登録
      await this.initializeSeasons();
      // 品種を初期登録
      await this.initializeBrands();
    },
    async doSignIn(username, password) {
      let user = await this.$Amplify.Auth.signIn(username, password);

      AmplifyEventBus.$emit("localUser", user);
      return user;
    }
  }
};
